"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceType = void 0;
var DeviceType;
(function (DeviceType) {
    DeviceType["Windows"] = "Windows";
    DeviceType["MacOS"] = "MacOS";
    DeviceType["Linux"] = "Linux";
})(DeviceType || (exports.DeviceType = DeviceType = {}));
//# sourceMappingURL=devices.js.map